import { useContext, useEffect } from 'react';
import pickBy from 'lodash/pickBy';
import type {
	ItemType,
	ItemMap,
} from '@atlassian/jira-favourite-change-provider/src/model/types.tsx';
import { FavoriteChangeContext } from '@atlassian/jira-favourite-change-provider/src/view/index.tsx';
import { usePreviousWithInitial } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';

type FavoritesChangeEffect = (
	hasPendingChanges: boolean,
	previousHasPendingChanges: boolean,
) => void;

export const useFavoritesChangeEffect = (type: ItemType, effect: FavoritesChangeEffect) => {
	const { items } = useContext(FavoriteChangeContext);
	// @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
	const typeItems: ItemMap = items[type];

	const pendingChanges = pickBy(typeItems, (item) => item.pending);
	const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
	const previousHasPendingChanges = usePreviousWithInitial(hasPendingChanges);

	useEffect(() => {
		effect(hasPendingChanges, previousHasPendingChanges);
	}, [effect, hasPendingChanges, previousHasPendingChanges]);
};
